

















import DailyAmount from '@/views/molecules/DailyAmount.vue'
import NotAcceptedDays from '@/views/molecules/NotAcceptedDays.vue'
import EmailText from '@/views/molecules/EmailText.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import store from '@/store'

export default
  components: {
    DailyAmount
    NotAcceptedDays
    EmailText
    CheckBox
  }

  data: () ->
    supplySourceNum: store.getters.getAdminData.supply_source
    level: store.getters.getAdminData.level

  methods: {
    switchSupplySource: (e) ->
      @supplySourceNum = e
  }
